import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRouter";
import LoginPage from "../Pages/Login/LoginPage";
import { HomePage } from "../Pages/Home/HomePage";
import ListaUsuariosPage from "../Pages/Cadastros/Usuarios/ListaUsuariosPage";
import FormUsuarioPage from "../Pages/Cadastros/Usuarios/FormUsuarioPage";
import { ListaRepresentantesPage } from "../Pages/Cadastros/Representantes/ListaRepresentantesPage";
import { FormRepresentantePage } from "../Pages/Cadastros/Representantes/FormRepresentantePage";
import { ListaLicencaPage } from "../Pages/Comercial/Licencas/ListaLicencaPage";
import { FormLicencaPage } from "../Pages/Comercial/Licencas/FormLicencaPage";
import { ListaSolicitacaoPage } from "../Pages/Comercial/Solicitacoes/ListaSolicitacaoPage";
import { FormSolicitacaoPage } from "../Pages/Comercial/Solicitacoes/FormSolicitacaoPage";
import { FormSolicitarLicencaPage } from "../Pages/Comercial/Solicitar/FormSolicitarLicencaPage";
import { SimuladorPage } from "../Pages/Comercial/Simulador/SimuladorPage";
import { ListaProspeccoesPage } from "../Pages/Comercial/prospeccoes/ListaProspeccoesPage";
import { FomrProspeccoesPage } from "../Pages/Comercial/prospeccoes/FormProspeccoesPage";
import { ListaContratosPage } from "../Pages/Comercial/Contratos/ListaContratosPage";
import { FormContratoPage } from "../Pages/Comercial/Contratos/FormContratoPage";


const AppRoutes: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/start/:hash" element={<LoginPage />} />
        <Route path="/home" element={<PrivateRoute element={<HomePage />} />} />

        {/*COMERCIAL*/}
        <Route path="/licencas" element={<PrivateRoute element={<ListaLicencaPage />} />} />
        <Route path="/licenca/:id" element={<PrivateRoute element={<FormLicencaPage />} />} />
        <Route path="/solicitacoes" element={<PrivateRoute element={<ListaSolicitacaoPage />} />} />
        <Route path="/solicitacao/:id" element={<PrivateRoute element={<FormSolicitacaoPage />} />} />
        <Route path="/solicitar" element={<PrivateRoute element={<FormSolicitarLicencaPage />} />} />
        <Route path="/simulador" element={<PrivateRoute element={<SimuladorPage />} />} />
        <Route path="/prospeccoes" element={<PrivateRoute element={<ListaProspeccoesPage />} />} />
        <Route path="/prospeccao/:id" element={<PrivateRoute element={<FomrProspeccoesPage />} />} />
        <Route path="/prospeccao" element={<PrivateRoute element={<FomrProspeccoesPage />} />} />
        <Route path="/proposta/criar/:sd43id" element={<PrivateRoute element={<SimuladorPage />} />} />
        <Route path="/proposta/copiar/:sd43id/:copiaid" element={<PrivateRoute element={<SimuladorPage />} />} />
        <Route path="/proposta/visualizar/:sd432id" element={<PrivateRoute element={<SimuladorPage />} />} />
        <Route path="/contratos" element={<PrivateRoute element={<ListaContratosPage />} />} />
        <Route path="/contrato/criar/:sd43id" element={<PrivateRoute element={<FormContratoPage />} />} />
        <Route path="/contrato/visualizar/:sd48id" element={<PrivateRoute element={<FormContratoPage />} />} />


        {/*CADASTROS*/}
        <Route path="/usuarios" element={<PrivateRoute element={<ListaUsuariosPage />} />} />
        <Route path="/usuario" element={<PrivateRoute element={<FormUsuarioPage />} />} />
        <Route path="/usuario/:id" element={<PrivateRoute element={<FormUsuarioPage />} />} />
        <Route path="/representantes" element={<PrivateRoute element={<ListaRepresentantesPage />} />} />
        <Route path="/representante" element={<PrivateRoute element={<FormRepresentantePage />} />} />
        <Route path="/representante/:id" element={<PrivateRoute element={<FormRepresentantePage />} />} />


        <Route path="*" element={<PrivateRoute element={<HomePage />} />} />

      </Routes>
    </HashRouter>
  );
};

export default AppRoutes;
